// External libraries
import { Component } from "react";

// Preact Signals
import { effect } from "@preact/signals-react";

// Utilities
import { Invisible } from "../../Utilities/EntryUtils";

export class ImageLabelField extends Component {
  constructor({ field, eventIndex, galleryParentName }) {
    super();
    const { fieldName, properties } = field;
    this.state = { invisible: false };
    this.fieldName = typeof eventIndex === "number" ? `${fieldName}_${eventIndex}` : fieldName;
    this.imageSrc = properties?.ImageSrc;
    this.imageWidth = properties?.ImageWidth;
    this.imageHeight = properties?.ImageHeight;
    this.label = properties?.Label;
    this.galleryParentName = galleryParentName;
    this.parameterValues = properties?.ParameterValues;
    this.visibilityRules = properties?.VisibilityRules;
    this.eventIndex = eventIndex;
    this.disposeDependencyEffect = () => {};
  }

  shouldComponentUpdate(_, nextState) {
    return this.state.invisible !== nextState.invisible;
  }

  componentDidMount() {
    if (this.visibilityRules) this.handleDependencyEffect();
  }

  componentWillUnmount() {
    this.disposeDependencyEffect();
  }

  handleDependencyEffect() {
    this.disposeDependencyEffect = effect(() => {
      const result = Invisible({
        VisibilityRules: this.visibilityRules,
        parameterValues: this.parameterValues,
        eventIndex: this.eventIndex,
        galleryName: this.galleryParentName,
      });
      this.setState({ invisible: result.invisible && !result.disabled });
    });
  }

  render() {
    if (this.state.invisible) return null;
    if (!this.imageSrc) return null;

    const hasExplicitSize = this.imageWidth || this.imageHeight;
    const GRID_COLUMN_MIN_WIDTH = 300;
    const width = Number(this.imageWidth);
    const columnSpan = width > 0 ? Math.max(1, Math.ceil(width / GRID_COLUMN_MIN_WIDTH)) : 1;

    return (
      <div
        data-testid={this.fieldName}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          minWidth: 0,
          ...(hasExplicitSize ? { gridColumn: `span ${columnSpan}` } : {}),
        }}
      >
        <img
          src={this.imageSrc}
          alt={this.label || this.fieldName}
          style={
            hasExplicitSize
              ? {
                  width: this.imageWidth ? `${this.imageWidth}px` : undefined,
                  height: this.imageHeight ? `${this.imageHeight}px` : undefined,
                  maxWidth: "100%",
                  objectFit: "fill",
                }
              : { maxWidth: "100%" }
          }
        />
        {this.label && (
          <span style={{ marginTop: "4px", fontSize: "12px", color: "inherit" }}>{this.label}</span>
        )}
      </div>
    );
  }
}
